import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: [
    "linkTree",
    "link-tree",
    "link tree",
    "InternalApp, Linktree, and Affiliates",
  ],
  iconColor: "#004F2D", // earth
  getIcon(options) {
    return createIcon(
      `<g style="mix-blend-mode:multiply">
        <rect x="5" y="5" width="14" height="14" fill="url(#pattern-link-tree)" />
      </g>
      <defs>
        <pattern
          id="pattern-link-tree"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlink:href="#image0_3993_18148" transform="scale(0.00444444)" />
        </pattern>
        <image
          id="image0_3993_18148"
          width="225"
          height="225"
          xlink:href="data:image/png;base64,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"
        />
      </defs>`,
      "#E5EDEA", // earth-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
